import { QueryClient } from '@tanstack/react-query';

/**
 * Single QueryClient instance shared across the app.
 * - 30 s staleTime is conservative for HR data (employees / structures rarely
 *   change minute-to-minute and the cache prevents waterfall fetches when
 *   navigating between pages).
 * - Disable retries on auth errors — ApiError(401) and a refused permission
 *   (403) are permanent, and retrying only keeps the page loading before the
 *   refusal shows.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const status = (error as any)?.status;
        if (status === 401 || status === 403) return false;
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});
